import {msToReadableTime} from "@/libs/helper";

export const NeoDuration: React.FC<any> = ({data, uid}) => {
  //console.log(data, uid);
  const duration = data[uid] || 0;

  return (
    <>
      <div className="flex gap-1">
        {duration === 0 ? "0 Min" : `${msToReadableTime(duration)}`}
      </div>
    </>
  );
};
